import React from "react";
import { FiX, FiMessageSquare } from "react-icons/fi";
import PhotoCarousel from "./PhotoCarousel";
import { FaRegHeart, FaHeart } from "react-icons/fa";

export default function ParkingDetailsModal({
  parking,
  onClose,
  onContactSeller,
  liked,
  onToggleLike,
  likeCount,
}) {
  if (!parking) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white z-10 p-4 border-b flex justify-between items-center">
          <h2 className="text-xl font-semibold text-eleghoBlue">
            {parking.title}
          </h2>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-500">{likeCount}</span>
              <button onClick={onToggleLike} className="text-2xl">
                {liked ? <FaHeart className="text-red-500" /> : <FaRegHeart />}
              </button>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            >
              <FiX className="w-6 h-6" />
            </button>
          </div>
        </div>

        <div className="p-4">
          {/* Image Carousel */}
          <div className="mb-6 rounded-lg overflow-hidden">
            {parking.images && parking.images.length > 0 ? (
              <PhotoCarousel images={parking.images} />
            ) : (
              <div className="w-full h-64 bg-gray-200 flex items-center justify-center">
                <span className="text-gray-400">No Image Available</span>
              </div>
            )}
          </div>

          {/* Type Badge */}
          <div className="mb-4">
            <span className="bg-blue-500 text-white text-sm font-bold px-3 py-1 rounded-lg">
              {parking.rentalType || "For Rent"}
            </span>
          </div>

          {/* Price */}
          <div className="mb-6">
            <h3 className="text-2xl font-bold text-eleghoBlue">
              ₱{parking.price}
            </h3>
          </div>

          {/* Parking Details */}
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-gray-600 mb-2">
              Parking Details
            </h4>
            <div className="space-y-2">
              <p className="text-gray-700">
                <span className="font-medium">Location:</span>{" "}
                {parking.location}
              </p>
              {parking.size && (
                <p className="text-gray-700">
                  <span className="font-medium">Size:</span> {parking.size}
                </p>
              )}
              {parking.description && (
                <p className="text-gray-700 whitespace-pre-wrap">
                  {parking.description}
                </p>
              )}
            </div>
          </div>

          {/* Owner Info */}
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-gray-600 mb-2">
              Owner Information
            </h4>
            <p className="text-gray-700">{parking.createdName}</p>
            {parking.contactNumber && (
              <p className="text-gray-700">Contact: {parking.contactNumber}</p>
            )}
          </div>

          {/* Contact Button */}
          <div className="sticky bottom-0 bg-white py-4">
            <button
              onClick={onContactSeller}
              className="w-full bg-eleghoBlue hover:bg-eleghoBlue/90 text-white py-3 px-4 rounded-md transition-colors duration-300 flex items-center justify-center gap-2"
            >
              <FiMessageSquare className="w-5 h-5" />
              Contact Owner
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
